import { endsWith } from 'lodash';

export class StringMethod {
    public static countTheLongestWord = (sentence: string): number => {
        const words: string[] = sentence.split(' ');
        let longestWordLength: number = 0;

        for (const word of words) {
            if (word.length > longestWordLength) {
                longestWordLength = word.length;
            }
        }

        return longestWordLength;
    };

    public static removeUnwantedCharactersFromEnd = (sentence: string, charactersToRemove: string[]): string => {
        let newSentence: string = sentence;
        let tested: boolean = false;

        while (tested === false) {
            let foundCharacter: string | null = null;
            charactersToRemove.some(character => {
                if (endsWith(newSentence, character)) {
                    foundCharacter = character;
                    return true;
                }
            });

            if (foundCharacter !== null && foundCharacter.length > 0) {
                newSentence = newSentence.slice(0, foundCharacter.length * -1);
            } else {
                tested = true;
            }
        }

        return newSentence;
    };

    public static removeFromBeginning = (sentence: string, charactersToRemove: string = ''): string => {
        let s: string = sentence || '';
        const firstCharacters = s.substr(0, charactersToRemove.length);

        if (firstCharacters.toLowerCase() === charactersToRemove.toLowerCase()) {
            s = s.substr(charactersToRemove.length);
        }

        return s;
    };

    public static isEmail = (email: string): boolean => {
        // tslint:disable-next-line:max-line-length
        const emailTest = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return emailTest.test(email.trim().toLowerCase());
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/string.ts